import React from "react";
import {
  Button,
  Card,
  CardContent,
  FormControlLabel,
  Grid,
  IconButton,
  Stack,
  Switch,
  TextField,
  Tooltip,
  Typography,
  CircularProgress,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import SaveIcon from "@mui/icons-material/Save";

const LocationFormCard = ({
  locationForm,
  locationErrors,
  editingLocationId,
  savingLocation,
  onChange,
  onSave,
  onReset,
  onRefresh,
}) => {
  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h6" fontWeight={700}>
            {editingLocationId ? "Edit Location" : "Add Location"}
          </Typography>
          <Stack direction="row" spacing={1}>
            <Tooltip title="Refresh">
              <IconButton onClick={onRefresh}>
                <RefreshIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Reset Form">
              <IconButton onClick={onReset}>
                <AddIcon />
              </IconButton>
            </Tooltip>
          </Stack>
        </Stack>

        <Grid container spacing={2}>
          {[
            ["name", "Location Name"],
            ["contact_number", "Contact Number"],
            ["address_line1", "Address Line 1"],
            ["street", "Street"],
            ["city", "City"],
            ["state", "State"],
            ["country", "Country"],
            ["postal_code", "Postal Code"],
            ["google_location_url", "Google Location URL"],
            ["google_location_id", "Google Location ID"],
            ["latitude", "Latitude"],
            ["longitude", "Longitude"],
          ].map(([field, label]) => (
            <Grid
              item
              xs={12}
              sm={
                ["address_line1", "street"].includes(field)
                  ? 12
                  : 6
              }
              key={field}
            >
              <TextField
                fullWidth
                label={label}
                value={locationForm[field]}
                onChange={(e) => onChange(field, e.target.value)}
                error={!!locationErrors[field]}
                helperText={locationErrors[field]}
              />
            </Grid>
          ))}

          <Grid item xs={12}>
            <Stack direction="row" spacing={2} flexWrap="wrap">
              <FormControlLabel
                control={
                  <Switch
                    checked={locationForm.is_primary}
                    onChange={(e) => onChange("is_primary", e.target.checked)}
                  />
                }
                label="Primary Location"
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={locationForm.is_active}
                    onChange={(e) => onChange("is_active", e.target.checked)}
                  />
                }
                label="Active"
              />
            </Stack>
          </Grid>

          <Grid item xs={12}>
            <Stack direction="row" spacing={1}>
              <Button
                variant="contained"
                startIcon={savingLocation ? <CircularProgress size={18} /> : <SaveIcon />}
                onClick={onSave}
                disabled={savingLocation}
              >
                {editingLocationId ? "Update Location" : "Create Location"}
              </Button>
              {editingLocationId && (
                <Button variant="outlined" onClick={onReset}>
                  Cancel
                </Button>
              )}
            </Stack>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default LocationFormCard;